import React from 'react';
import PromptGenerator from './PromptGenerator';

function App() {
  return <PromptGenerator />;
}

export default App;
